import React from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import icons from "../../assets/images/sprite-other-icons.svg";

function WithdrawUnavailable() {
  const navigate = useNavigate();
  const { balanceDetails } = useSelector((state) => state?.signIn);
  const withdrawableBalance =
    balanceDetails?.real_balance?.result?.withdrawls;

  const goBack = () => {
    navigate("/");
  };
  return (
    <React.Fragment>
      <div className="SB-page-content">
        <div className="SB-myAccountSection-container SB-deposit">
          <div className="SB-pageHeader">
            <div className="SB-pageBackButton">
              <div className="SB-iconSVG" onClick={goBack}>
                <svg xmlns="http://www.w3.org/2000/svg">
                  <use xlinkHref={`${icons}#icon-back`} />
                </svg>
              </div>
            </div>
            <div className="SB-pageHeader-title">Withdraw</div>
          </div>

          <div id="SB-deposit-chooseMethod">
            <div className="SB-content">
              <div className="SB-msgBox SB-error">
                <div className="SB-msgBox-container">
                  Withdrawals are currently unavailable. Please try again
                  later.
                </div>
              </div>
              <div className="SB-contentBlock SB-withdrawBalance-block">
                <div className="SB-leftContent">
                  <div className="SB-balanceLabel">Withdrawable Balance</div>
                </div>
                <div className="SB-rightContent">
                  <div className="SB-userBalance">
                    {" "}
                    {withdrawableBalance?.toLocaleString() ?? 0}{" "}
                  </div>
                </div>
              </div>
              <div className="SB-space10"></div>
              <button
                className="btn SB-btnSecondary SB-btnLarge active"
                id="SB-btn-Deposit"
                onClick={goBack}
              >
                <div className="SB-btnTxt">Back to Home</div>
              </button>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

export default WithdrawUnavailable;
